import { withTranslation as withTranslationLib } from '@pletly/common';
import i18nInit from '../i18n';

export function withTranslation<ComponentProps extends object>(
	component: React.ComponentType<ComponentProps>,
) {
	return withTranslationLib(component, i18nInit);
}
